(function () {
  "use strict";

  var AWG_TO_MM2 = {
    "24": 0.20473,
    "23": 0.25816,
    "22": 0.32553,
    "21": 0.41049,
    "20": 0.51762,
    "19": 0.65269,
    "18": 0.82323,
    "17": 1.03784,
    "16": 1.30869,
    "15": 1.65020,
    "14": 2.08091,
    "13": 2.62400,
    "12": 3.30877,
    "11": 4.17184,
    "10": 5.26115,
    "9": 6.63420,
    "8": 8.36556,
    "7": 10.5488,
    "6": 13.3018,
    "5": 16.7732,
    "4": 21.1506,
    "3": 26.6705,
    "2": 33.6308,
    "1": 42.4077,
    "1/0": 53.4751,
    "2/0": 67.4309,
    "3/0": 85.0288,
    "4/0": 107.2193,
    "250 kcmil": 126.6769,
    "300 kcmil": 152.0122,
    "350 kcmil": 177.3476,
    "400 kcmil": 202.6830,
    "450 kcmil": 228.0184,
    "500 kcmil": 253.3537,
    "600 kcmil": 304.0245,
    "700 kcmil": 354.6952,
    "750 kcmil": 380.0306,
    "800 kcmil": 405.3660,
    "900 kcmil": 456.0367,
    "1000 kcmil": 506.7075
  };

  var AWG_ORDER = Object.keys(AWG_TO_MM2);

  function diameterFromMm2(mm2) {
    return 2 * Math.sqrt(mm2 / Math.PI);
  }

  function nearestAwg(mm2) {
    var best = null;
    var bestDiff = Infinity;

    AWG_ORDER.forEach(function (label) {
      var diff = Math.abs(AWG_TO_MM2[label] - mm2);

      if (diff < bestDiff) {
        bestDiff = diff;
        best = label;
      }
    });

    return best;
  }

  function displayAwgLabel(label) {
    if (label.indexOf("kcmil") !== -1) {
      return label;
    }

    return "AWG " + label;
  }

  function initAwgCalculator(widget) {
    if (widget.dataset.bwAwgInitialized === "true") {
      return;
    }

    var awgSelect = widget.querySelector('[data-field="awg"]');
    var diameterInput = widget.querySelector('[data-field="diameter"]');
    var sectionInput = widget.querySelector('[data-field="section"]');
    var note = widget.querySelector('[data-role="awg-note"]');

    if (!awgSelect || !diameterInput || !sectionInput) {
      return;
    }

    widget.dataset.bwAwgInitialized = "true";

    var nearestNote =
      widget.dataset.nearestNote ||
      "The closest standard AWG or kcmil size is shown when the entered value falls between two sizes.";

    var closestTemplate =
      widget.dataset.closestTemplate ||
      "Closest standard size: __SIZE__ (__MM2__ mm²).";

    AWG_ORDER.forEach(function (label) {
      var option = document.createElement("option");

      option.value = label;
      option.textContent = displayAwgLabel(label);

      awgSelect.appendChild(option);
    });

    function setNote(text) {
      if (note) {
        note.textContent = text || "";
      }
    }

    function formatSection(value) {
      if (value < 1) {
        return value.toFixed(3);
      }

      return value.toFixed(2);
    }

    function makeClosestMessage(label) {
      return closestTemplate
        .replace("__SIZE__", displayAwgLabel(label))
        .replace("__MM2__", formatSection(AWG_TO_MM2[label]));
    }

    function fromAwg() {
      var label = awgSelect.value;

      if (!label || !Object.prototype.hasOwnProperty.call(AWG_TO_MM2, label)) {
        diameterInput.value = "";
        sectionInput.value = "";
        return;
      }

      var mm2 = AWG_TO_MM2[label];

      diameterInput.value = diameterFromMm2(mm2).toFixed(3);
      sectionInput.value = formatSection(mm2);

      setNote("*" + nearestNote);
    }

    function fromDiameter() {
      var diameter = parseFloat(diameterInput.value);

      if (isNaN(diameter) || diameter <= 0) {
        return;
      }

      var mm2 = Math.PI * Math.pow(diameter / 2, 2);
      var label = nearestAwg(mm2);

      awgSelect.value = label;
      sectionInput.value = formatSection(mm2);

      setNote(makeClosestMessage(label));
    }

    function fromSection() {
      var mm2 = parseFloat(sectionInput.value);

      if (isNaN(mm2) || mm2 <= 0) {
        return;
      }

      var label = nearestAwg(mm2);

      awgSelect.value = label;
      diameterInput.value = diameterFromMm2(mm2).toFixed(3);

      setNote(makeClosestMessage(label));
    }

    awgSelect.addEventListener("change", fromAwg);
    diameterInput.addEventListener("input", fromDiameter);
    sectionInput.addEventListener("input", fromSection);
  }

  function initWireSectionCalculator(widget) {
    if (widget.dataset.bwWireInitialized === "true") {
      return;
    }

    var table = widget.querySelector('[data-bw-calc="wire-section"]');

    if (!table) {
      return;
    }

    var lengthInput = table.querySelector('[data-field="length"]');
    var voltageInput = table.querySelector('[data-field="voltage"]');
    var wattageInput = table.querySelector('[data-field="wattage"]');
    var amperageInput = table.querySelector('[data-field="amperage"]');
    var resultInput = table.querySelector('[data-field="result"]');

    if (
      !lengthInput ||
      !voltageInput ||
      !wattageInput ||
      !amperageInput ||
      !resultInput
    ) {
      return;
    }

    widget.dataset.bwWireInitialized = "true";

    var RHO = 0.0179;
    var MAX_VOLTAGE_DROP = 0.03;
    var lastEdited = null;

    function num(input) {
      var value = parseFloat(input.value);

      if (isNaN(value) || value <= 0) {
        return null;
      }

      return value;
    }

    function syncDerivedValues() {
      var voltage = num(voltageInput);

      if (voltage === null) {
        return;
      }

      if (lastEdited === "wattage") {
        var wattage = num(wattageInput);

        if (wattage !== null) {
          amperageInput.value = (wattage / voltage).toFixed(2);
        } else {
          amperageInput.value = "";
        }

        return;
      }

      if (lastEdited === "amperage") {
        var amperage = num(amperageInput);

        if (amperage !== null) {
          wattageInput.value = (amperage * voltage).toFixed(2);
        } else {
          wattageInput.value = "";
        }

        return;
      }

      var existingWattage = num(wattageInput);
      var existingAmperage = num(amperageInput);

      if (existingWattage !== null) {
        amperageInput.value = (existingWattage / voltage).toFixed(2);
      } else if (existingAmperage !== null) {
        wattageInput.value = (existingAmperage * voltage).toFixed(2);
      }
    }

    function getCurrent() {
      var voltage = num(voltageInput);

      if (voltage === null) {
        return null;
      }

      if (lastEdited === "amperage") {
        return num(amperageInput);
      }

      if (lastEdited === "wattage") {
        var wattage = num(wattageInput);

        if (wattage === null) {
          return null;
        }

        return wattage / voltage;
      }

      var amperage = num(amperageInput);

      if (amperage !== null) {
        return amperage;
      }

      var fallbackWattage = num(wattageInput);

      if (fallbackWattage !== null) {
        return fallbackWattage / voltage;
      }

      return null;
    }

    function recalcSection() {
      var length = num(lengthInput);
      var voltage = num(voltageInput);
      var current = getCurrent();

      if (
        length === null ||
        voltage === null ||
        current === null
      ) {
        resultInput.value = "";
        return;
      }

      var allowedVoltageDrop = voltage * MAX_VOLTAGE_DROP;

      var section =
        (RHO * length * current) /
        allowedVoltageDrop;

      resultInput.value =
        section > 0 ? section.toFixed(2) : "";
    }

    function onWattageInput() {
      lastEdited = "wattage";
      syncDerivedValues();
      recalcSection();
    }

    function onAmperageInput() {
      lastEdited = "amperage";
      syncDerivedValues();
      recalcSection();
    }

    function onVoltageInput() {
      syncDerivedValues();
      recalcSection();
    }

    lengthInput.addEventListener("input", recalcSection);
    voltageInput.addEventListener("input", onVoltageInput);
    wattageInput.addEventListener("input", onWattageInput);
    amperageInput.addEventListener("input", onAmperageInput);
  }

  function init(root) {
    var widgets = [];

    if (
      root &&
      root.matches &&
      root.matches(".bw-calc-widget")
    ) {
      widgets.push(root);
    }

    if (root && root.querySelectorAll) {
      root
        .querySelectorAll(".bw-calc-widget")
        .forEach(function (widget) {
          widgets.push(widget);
        });
    }

    widgets.forEach(function (widget) {
      initAwgCalculator(widget);
      initWireSectionCalculator(widget);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();